import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdatePodcastTagsMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.updateTags,
  {
    mutationKey: ['updatePodcastTags'],
  },
)
